import React from 'react'
import PropTypes from 'prop-types'

const Button = ({ label, kind, enabled, onClick }) => (
  <button
    className={`uk-button uk-button-small${kind ? ` uk-button-${kind}` : ''} submission-controls-button`}
    disabled={!enabled}
    onClick={() => onClick()}
  >
    {label}
  </button>
)

function SubmissionControls(props) {
  const { canSaveAllFiles, canSubmit, isSubmitting, isSubmissionPending, onSaveAllFiles, onSubmit, onFocusSubmission, sidebarIsCollapsed, onToggleSidebar } = props
  const submitLabel = isSubmitting ? 'Submitting...' : (isSubmissionPending ? 'Awaiting Results...' : 'Submit Code')
  return (
    <div className="submission-controls">
      <div className="submission-controls-show-sidebar-button">
        <Button
          label={sidebarIsCollapsed ? '\u2192' : '\u2190'}
          enabled={true}
          onClick={onToggleSidebar}
        />
      </div>
      <div className="submission-controls-button-group">
        <Button
          label="Save All Files"
          kind="primary"
          enabled={canSaveAllFiles}
          onClick={onSaveAllFiles}
        />
        <Button
          label={submitLabel}
          kind={isSubmissionPending ? 'secondary' : 'primary'}
          enabled={isSubmissionPending || canSubmit}
          onClick={isSubmissionPending ? onFocusSubmission : onSubmit}
        />
      </div>
    </div>
  )
}
SubmissionControls.propTypes = {
  canSaveAllFiles: PropTypes.bool.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isSubmissionPending: PropTypes.bool.isRequired,
  onSaveAllFiles: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onFocusSubmission: PropTypes.func.isRequired,
  sidebarIsCollapsed: PropTypes.bool.isRequired,
  onToggleSidebar: PropTypes.func.isRequired,
}

export default SubmissionControls
